/**
 * The sidebar's nav-item icon for `/notifications`. Kept separate from
 * `NotificationBell.tsx`'s own bell glyph so the sidebar (`app/nav.ts`)
 * doesn't have to import the whole dropdown component just for its icon.
 * Same 18x18 stroke-icon shape as `app/icons.tsx`'s set, so it sits flush
 * with the rest of the sidebar.
 */
import type { SVGProps } from 'react';

export function NotificationBellNavIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M4 7a5 5 0 0 1 10 0c0 3.5 1 4.5 1 4.5H3S4 10.5 4 7Z" />
      <path d="M7.5 14a1.5 1.5 0 0 0 3 0" />
    </svg>
  );
}
